import { DateRangeType } from '../../../../shared/domain/date-range-type.enum';
import { ActivityStatus } from '../../../../shared/domain/activity-status.model';

export class ReportFilter {
  dateRange?: DateRangeType;
  dateFrom: string;
  dateTo: string;
  bidder?: any;
  mergeCompanionUnits?: boolean;
  vastUnits?: boolean;
  videoUnits?: boolean;
  vastVideoUnits?: boolean;
  widgets?: string[];
  activityStatuses?: ActivityStatus[];
  publisherActivityStatuses?: ActivityStatus[];
  adUnitIds?: string[];
  publisherIds?: string[];
  ebAssociatedPublisherIds?: string[];
  ebChannel?: string;
  siteIds?: string[];
  excludeDfpSourceBidderRevenue?: boolean;
  demandPartnerIds?: string[];
  cxDemandCompanyIds?: string[];
  demandPartnerDisplayNames?: string[];

}
